import { getStorage, ref, deleteObject } from "firebase/storage";

// Exportiere die Funktion direkt
export const deleteImage = async (imageUrl) => {
    try {
      if (!imageUrl) return;
  
      const storage = getStorage();
      const imageRef = ref(storage, imageUrl);
  
      await deleteObject(imageRef);
      console.log("Bild erfolgreich gelöscht:", imageUrl);
    } catch (error) {
      console.error("Fehler beim Löschen des Bildes:", error);
    }
  };